module.exports = __webpack_public_path__ + "static/media/picto-blue-slow.a2ab3aca.png";